import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */
export const controller: ThemeUICSSObject = {
  /* PREPEND HERE */

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  height: '100%',
  gap: 3,
  flexBasis: '50vh',
  flexGrow: 1,

  '.autoscrollContainer, .chatHistoryVirtualScroller': {
    flexGrow: 1,
    flexShrink: 1,
    overflow: 'auto',
    minHeight: 0,
  },

  '.search_controls': {
    flexShrink: 0,
  },

  '.assistantHistory': {
    flexGrow: 1,
    overflow: 'auto',
    maxHeight: '77vh',
  },

  '.chatPlan': {
    background: '#fff',
    border: '1px solid',
    borderColor: 'palette.border.field',
    borderRadius: '6px',
    boxShadow: '0 6px 18px rgb(0 0 0 / 10%)',
    flex: '0 0 auto',
    maxWidth: '100%',
    minWidth: 0,
    overflow: 'hidden',
    position: 'sticky',
    bottom: 0,
    zIndex: 2,
  },

  '.chatPlan__items': {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '72px',
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    py: 1,
  },

  '.chatPlanItem': {
    alignItems: 'center',
    color: 'palette.text.primary',
    display: 'flex',
    flex: '0 0 24px',
    gap: 2,
    minHeight: '24px',
    minWidth: 0,
    px: 2,
  },

  '.chatPlanItem__check': {
    border: '1px solid',
    borderColor: 'palette.border.field',
    borderRadius: '50%',
    flex: '0 0 12px',
    height: '12px',
    position: 'relative',
    width: '12px',
  },

  '.chatPlanItem__text': {
    flex: '1 1 auto',
    fontSize: '12px',
    lineHeight: '16px',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  '.chatPlanItem--done': {
    color: 'palette.text.disabled',

    '.chatPlanItem__check': {
      background: '#eef7f0',
      borderColor: '#75a880',

      '&:after': {
        borderBottom: '1px solid #327a44',
        borderRight: '1px solid #327a44',
        content: '""',
        height: '6px',
        left: '4px',
        position: 'absolute',
        top: '1px',
        transform: 'rotate(45deg)',
        width: '3px',
      },
    },

    '.chatPlanItem__text': {
      textDecoration: 'line-through',
    },
  },
};
